import React, { useEffect, useState } from 'react';
import { Search as SearchIcon } from 'react-feather';
import 'components/LoginPage/LoginPage.scss';
import './LocalProductSearchPage.scss';
import { IconButton, Spinner, TextField, Typography } from 'ui-kit';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import { getLocalProductsList } from 'api/products';
import { message } from 'antd';
import { LocalProduct } from 'api/types/localproduct';
import LocalProductCard from 'components/ProductCard/LocalProductCard/LocalProductCard';
import LocalProductPreviewModal from 'components/LocalProductPreviewModal';
import { useHistory, useLocation } from 'react-router-dom';
import { addQueryParams } from 'utils/utilsV2';
import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';

export type ActorType = 'owner' | 'guest' | 'merchant';

const INITIAL_MESSAGE = 'Enter your postal code to find any local products in your area!';

const SEARCH_KEY = 'search';

export default function OrderRequestPage() {
  const [searchInput, setSearchInput] = useState<string | null>();
  const [hasSearched, setHasSearched] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [products, setProducts] = useState<LocalProduct[]>();
  const [selectedProduct, setSelectedProduct] = useState<LocalProduct>(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { search } = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const searchKey = searchParams.get(SEARCH_KEY);
    if (searchKey) {
      setSearchInput(searchKey);
      searchLocalProducts(searchKey);
    }
  }, [search]);

  const searchLocalProducts = (searchKey: string) => {
    history.push(
      addQueryParams({
        url: reverse({ url: URLS.VENDORS }),
        queryParams: {
          [SEARCH_KEY]: searchKey,
        },
      }),
    );

    setHasSearched(true);
    setLoading(true);
    getLocalProductsList({ postalCode: searchKey }).then((res) => {
      if (res.ok) {
        setProducts(res.data);
      } else {
        message.error(
          'Something went wrong while searching for local products. Please try again later.',
        );
      }
      setLoading(false);
    });
  };
  const handleSearch = (e) => {
    e.preventDefault();
    searchLocalProducts(searchInput);
  };
  const handleCardClick = (product: LocalProduct) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };
  return (
    <div className="LocalProductSearchPage">
      <LocalProductPreviewModal
        isOpen={isModalOpen}
        product={selectedProduct}
        onClose={handleModalClose}
      />
      <Header />
      <div className="LocalProductSearchPage_content">
        <form onSubmit={handleSearch} className="LocalProductSearchPage_form">
          <TextField
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => searchLocalProducts(searchInput)}>
                  <SearchIcon />
                </IconButton>
              ),
            }}
            placeholder="Search by postal code"
          />
        </form>
        {!hasSearched && (
          <Typography variant="body1" className="LocalProductSearchPage_message">
            {INITIAL_MESSAGE}
          </Typography>
        )}
        <div className="ProductCardContainer">
          {loading && <Spinner />}
          {hasSearched &&
            !loading &&
            products?.map((product) => (
              <LocalProductCard
                key={product.id}
                product={product}
                onClick={() => handleCardClick(product)}
              />
            ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
